import { Routes } from '@angular/router';

import {
  authGuard,
  guestGuard,
  onboardingGuard,
  recoveryGuard,
} from './features/auth/guards/auth.guards';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'register',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/pages/register/register.page').then(
        (m) => m.RegisterPage,
      ),
  },
  {
    path: 'forgot-password',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/pages/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage,
      ),
  },
  {
    path: 'update-password',
    canActivate: [recoveryGuard],
    loadComponent: () =>
      import('./features/auth/pages/update-password/update-password.page').then(
        (m) => m.UpdatePasswordPage,
      ),
  },
  {
    path: 'onboarding',
    canActivate: [onboardingGuard],
    loadComponent: () =>
      import('./features/auth/pages/onboarding/onboarding.page').then(
        (m) => m.OnboardingPage,
      ),
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./features/auth/pages/auth-callback/auth-callback.page').then(
        (m) => m.AuthCallbackPage,
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/home/home-placeholder.page').then(
        (m) => m.HomePlaceholderPage,
      ),
  },
  { path: '**', redirectTo: '' },
];
